// Utilities copied from the original component without any logic changes.

// ---------- Validators ----------
export const validateEmail = (email) => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
};

export const validatePhoneNumber = (phoneNumber) => {
  const phonePattern = /^[6-9][0-9]{9}$/;
  return phonePattern.test(phoneNumber);
};

export const validatePincode = (pincode) => {
  const pincodePattern = /^[1-9][0-9]{5}$/;
  return pincodePattern.test(pincode);
};

export const validateAadhaar = (aadhaar) => {
  const expr =
    /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/;
  return expr.test(aadhaar);
};

export const validatePAN = (pan) => {
  const regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
  return regex.test(pan.toUpperCase());
};

// ---------- Date helpers ----------
export const calculateAge = (dateOfBirth) => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const calculateExpiryDate = (tenure) => {
  const currentDate = new Date();
  currentDate.setFullYear(currentDate.getFullYear() + parseInt(tenure));
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const calculateIssueDate = () => {
  const currentDate = new Date();
  currentDate.setFullYear(currentDate.getFullYear());
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// ---------- Files ----------
export const MAX_FILE_SIZE = 1024 * 1024; // 1 MB (kept identical)

export const checkFileSize = (file) => {
  return file.size <= MAX_FILE_SIZE;
};

// ---------- Pricing transformers ----------
export const transformPricingData = (data) => {
  const result = {};
  data.forEach((item) => {
    const years = item["insuranceCoverageYears"];
    delete item["insuranceCoverageYears"];
    result[years] = item;
  });
  return result;
};

export const transformPricingDataGpa = (data) => {
  const result = {};
  data.forEach((item) => {
    const years = item["insuranceCoverageYears"];
    delete item["insuranceCoverageYears"];
    result[years] = item;
  });
  return result;
};
